import { render, staticRenderFns } from "./HeadComponent.vue?vue&type=template&id=2e79999e&scoped=true"
import script from "./HeadComponent.vue?vue&type=script&lang=js"
export * from "./HeadComponent.vue?vue&type=script&lang=js"
import style0 from "./HeadComponent.vue?vue&type=style&index=0&id=2e79999e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79999e",
  null
  
)

export default component.exports